export const css = `
  .images {
    display: flex;
    gap: 2.5mm;
    width: 100%;
  }

  .images img {
    border-radius: 1em;
    object-fit: cover;
    height: 36mm;
    width: 36mm;
  }

  .empty-container {
    height: 45px;
    width: 100%;
  }

  .no-print { display: none; }
  .print { opacity: 1 !important; height: initial !important; }
`;
